<template>
  <div>
<nav class="shell">
        <ul class="buttons">
            <li class="li">
                子站列表
                <ul>
                    <li>
                         <a href="https://my.wulvxinchen.cn/tools">工具站</a>
                    </li>
                    <li>
                         <a href="https://my.wulvxinchen.cn/pictures">图片站</a>
                    </li>
                </ul>
            </li>
            
            <li class="li">
                小工具
                <ul>
                    <li>
                        <a href="https://my.wulvxinchen.cn/hutaolive">胡桃Live2D</a>
                    </li>
                    <li>
                        <a href="https://my.wulvxinchen.cn/genshincard">原神名片生成</a>
                    </li>
                    <li>
                        <a href="https://my.wulvxinchen.cn/helpbaidu">让我帮你百度一下</a>
                    </li>
                    <li>
                        <a href="https://my.wulvxinchen.cn/todolist">待办列表</a>
                    </li>
                </ul>   
            </li>
            <li class="li">
                常用网站快捷方式
                <ul>
                    <li>
                        <a href="https://wulvxinchen.cn/">心尘的引导站</a>
                    </li>
                    <li>
                        <a href="https://bbs.nga.cn/">NGA玩家社区</a>
                    </li>
                    <li>
                        <a href="https://www.bilibili.com/">哔哩哔哩</a>
                    </li>
                    <li>
                        <a href="https://www.google.com/">谷歌</a>
                    </li>
                    <li>
                        <a href="https://www.baidu.com/">百度</a>
                    </li>
                    <li>
                        <a href="https://www.taobao.com/">淘宝</a>
                    </li>
                    <li>
                        <a href="https://www.zhihu.com/">知乎</a>
                    </li>
                </ul> 
            </li>
        </ul>
    </nav>
  </div>
</template>

<script>
export default {
    name:'LeftMenu'
}
</script>

<style>
        * {
            list-style-type: none;
            padding: 0;
            margin: 0;
        }
        .shell{
            position:fixed;
            
            width: 280px;
            height: 92%;
            background-color: #8a98c9;
            border-radius: 0.5em;
        }
        .buttons{
            margin: 60px 0;
            color: #fff;
        }
        .li{
            letter-spacing: 2px;
            font: 600 17px '';
            padding: 16px 52px;
            transition: .3s;
        }
        .li::after{
            content: '';
            position: absolute;
            left: 20px;
            margin-top: -22px;
            display: block;
            width: 20px;
            height: 20px;
            background-color: #fff;
            border-radius: 50%;
        }
        .buttons>li:hover{
            background-color: #beb5df;
        }
        
        .li ul{
            width: 0;
            height: 100%;
            padding: 60px 0;
            position: absolute;
            top: 0;
            right: 0;
            overflow: hidden;
            background-color: #59699b;
            transition: .3s;
        }

        .li ul li{
            padding: 16px 24px;
            transition: .3s;
        }

        .li:hover ul{
            width: 228px;
        }
        .li ul li:hover{
            background-color: #828eb9;
        }
        
        a{
            text-decoration: none;
            user-select: none;
            color: #ffffff;
        }
        li{
            user-select: none;
        }
        a:hover{
            color: #c6c6c6;
        }
</style>